export default __webpack_public_path__ + "static/media/excel.27ae6b9f.svg";